module.exports = __webpack_public_path__ + "img/chapter-3-thumb.260ef3cc.jpg";